/**
 * Region on a canvas-artifacts/gcp/subnet object ({ data: { region } }).
 */
export function regionFromArtifact(value) {
  if (!value || typeof value !== 'object') return null;
  const nested = value.data && typeof value.data === 'object' ? value.data.region : null;
  if (typeof nested === 'string' && nested.trim()) return nested.trim();
  if (typeof value.region === 'string' && value.region.trim()) return value.region.trim();
  return null;
}

export function regionFromSourceNode(sourceNode, sourceHandle) {
  if (!sourceNode?.data) return null;
  const fromArtifact = regionFromArtifact(
    sourceNode.data.output_data?.[sourceHandle]
  );
  if (fromArtifact) return fromArtifact;
  const fromParams = sourceNode.data.parameter_data?.region;
  if (typeof fromParams === 'string' && fromParams.trim()) return fromParams.trim();
  return null;
}

/**
 * Region a downstream node should inherit from inbound edges (typically a subnet).
 */
export function inheritRegionFromUpstream(node, nodes, edges) {
  if (!node?.data?.parameters?.properties?.region) return null;
  const incoming = (edges || []).filter((edge) => edge.target === node.id);
  for (const edge of incoming) {
    const source = (nodes || []).find((n) => n.id === edge.source);
    const region = regionFromSourceNode(source, edge.sourceHandle);
    if (region) return region;
  }
  return null;
}

export function applyInheritedRegionToForm(schema, formData, inherited) {
  if (!inherited || !schema?.properties?.region) {
    return { schema, formData, inherited: false };
  }
  const prior = schema.properties.region || {};
  return {
    schema: {
      ...schema,
      properties: {
        ...schema.properties,
        region: {
          ...prior,
          readOnly: true,
          description: [prior.description, 'Inherited from the connected subnet.']
            .filter(Boolean)
            .join(' '),
        },
      },
    },
    formData: { ...(formData || {}), region: inherited },
    inherited: true,
  };
}
